import { render, staticRenderFns } from "./GeraInside.vue?vue&type=template&id=7f569706&scoped=true"
import script from "./GeraInside.vue?vue&type=script&lang=js"
export * from "./GeraInside.vue?vue&type=script&lang=js"
import style0 from "./GeraInside.vue?vue&type=style&index=0&id=7f569706&prod&lang=css"
import style1 from "./GeraInside.vue?vue&type=style&index=1&id=7f569706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f569706",
  null
  
)

/* custom blocks */
import block0 from "./GeraInside.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports